module.exports = __webpack_public_path__ + "img/photo-0089.388ac13d.jpg";